import styles from "./Loader.module.css";
import React from "react";

// Loading spinner with animation
export default function Loader() {
	return <div className={styles.div} />;
}
